import { call, put, takeLatest } from 'redux-saga/effects';
import { loadingRequest, loadingSuccess } from '@stores/global/actions.js';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal.jsx';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig.js';
import {
  cancelReceiptService,
  getDebtByPolicyForRenewalPremService,
  getDebtByPolicyOrAppNoService,
  getListLoveService,
  getReceiptDetailService,
  getSearchReceiptService,
  getValidAgentService,
  saveReceiptService,
} from '@services/fee/fee.js';
import {
  setListLoveDataAction,
  setReceiptDetailDataAction,
  setReceiptListDataAction,
} from '@stores/fee/action.js';
import { hasValue } from '@helpers/utils/utils.js';
import {
  CANCEL_RECEIPT_DATA,
  GET_DEBT_BY_POL_APP_DATA,
  GET_DEBT_BY_POL_FOR_RENEWAL_PREM_DATA,
  GET_LIST_LOV_DATA,
  GET_RECEIPT_DETAIL_DATA,
  GET_RECEIPT_LIST_DATA,
  GET_VALID_AGENT_DATA,
  SET_RECEIPT_DATA,
} from '@stores/fee/constants.js';

export function* getListLoveData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getListLoveService, payload);
    yield put(loadingSuccess());

    if (hasValue(response) && response?.status === 'SUCCESS') {
      yield put(setListLoveDataAction(response));
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getReceiptListData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getSearchReceiptService, payload);
    yield put(loadingSuccess());

    if (hasValue(response) && response?.status === 'SUCCESS') {
      yield put(setReceiptListDataAction(response.data));
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getReceiptDetailData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getReceiptDetailService, payload);
    yield put(loadingSuccess());

    if (hasValue(response) && response?.status === 'SUCCESS') {
      yield put(setReceiptDetailDataAction(response?.data?.content));
    }
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getValidAgent({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getValidAgentService, payload);
    yield put(loadingSuccess());

    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getDebtByPolicyOrAppNo({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getDebtByPolicyOrAppNoService, payload);
    yield put(loadingSuccess());

    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getDebtByPolicyForRenewalPrem({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getDebtByPolicyForRenewalPremService, payload);
    yield put(loadingSuccess());

    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* setReceipt({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(saveReceiptService, payload);
    yield put(loadingSuccess());

    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    if (callback) callback(err?.response?.data);
    else {
      GlobalModal.openOnce({
        title: 'Error',
        message: ErrorLevelConfig.SAGA.FETCH_ERROR,
        onOk: () => {
          // Do nothing
        },
      });
    }
  }
}

export function* cancelReceipt({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(cancelReceiptService, payload);
    yield put(loadingSuccess());

    if (callback) callback(response);
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    if (callback) callback(err?.response?.data);
    else {
      GlobalModal.openOnce({
        title: 'Error',
        message: ErrorLevelConfig.SAGA.FETCH_ERROR,
        onOk: () => {
          // Do nothing
        },
      });
    }
  }
}

export default function* feeSaga() {
  yield takeLatest(GET_RECEIPT_LIST_DATA, getReceiptListData);
  yield takeLatest(GET_LIST_LOV_DATA, getListLoveData);
  yield takeLatest(GET_RECEIPT_DETAIL_DATA, getReceiptDetailData);
  yield takeLatest(GET_VALID_AGENT_DATA, getValidAgent);
  yield takeLatest(GET_DEBT_BY_POL_APP_DATA, getDebtByPolicyOrAppNo);
  yield takeLatest(
    GET_DEBT_BY_POL_FOR_RENEWAL_PREM_DATA,
    getDebtByPolicyForRenewalPrem,
  );
  yield takeLatest(SET_RECEIPT_DATA, setReceipt);
  yield takeLatest(CANCEL_RECEIPT_DATA, cancelReceipt);
}
